const ANY_TAG = /<\/?[a-z][a-z0-9-]*(?:\s[^<>]*)?\/?>/i;

const TAG_WITH_ATTRS = /<\/?([a-z][a-z0-9-]*)((?:\s[^<>]*?)?)\/?>/gi;

const PLAIN_EQUIVALENT_TAGS = new Set(['p', 'br', 'div']);

export function looksLikeHtml(value: string): boolean {
  return ANY_TAG.test(value || '');
}

export function isPlainEquivalentHtml(value: string): boolean {
  const html = value || '';
  TAG_WITH_ATTRS.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = TAG_WITH_ATTRS.exec(html)) !== null) {
    const [, name, attrs] = match;
    if (!PLAIN_EQUIVALENT_TAGS.has(name.toLowerCase())) return false;
    if (attrs && attrs.trim()) return false;
  }
  return true;
}

const decodeEntities = (text: string): string =>
  text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0*39;|&apos;/gi, "'")
    .replace(/&amp;/gi, '&');

export function htmlToPlainText(html: string): string {
  return decodeEntities(
    (html || '')
      .replace(/<\s*br\s*\/?\s*>/gi, '\n')
      .replace(/<\s*\/\s*(?:p|div)\s*>/gi, '\n\n')
      .replace(/<[^>]*>/g, ''),
  )
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

const escapeHtml = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export function descriptionToHtml(value: string): string {
  const text = value || '';
  if (!text.trim()) return '';
  if (looksLikeHtml(text)) return text;
  return text
    .trim()
    .split(/\n{2,}/)
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

export function seedDescriptionForEditing(bodyHtml: string | null | undefined): {
  value: string;
  isHtml: boolean;
} {
  const raw = bodyHtml || '';
  if (!looksLikeHtml(raw)) return { value: raw, isHtml: false };
  if (isPlainEquivalentHtml(raw)) return { value: htmlToPlainText(raw), isHtml: false };
  return { value: raw, isHtml: true };
}
